const CLAIM_KEY = "fgh-welcome-bonus-claimed"
export const ARTICLES_AGENT_CODE = "ANG000"
let claimedInMemory = false

export const isArticlesPath = (pathname = "") =>
  pathname === "/articles" || pathname.startsWith("/articles/")

export const claimWelcomeBonusRegistration = () => {
  if (!isArticlesPath(window.location.pathname) && !hasWelcomeBonusClaim()) return false
  claimedInMemory = true
  try {
    window.sessionStorage.setItem(CLAIM_KEY, "true")
  } catch {
    // Keep the claim in memory when browser storage is unavailable.
  }
  return true
}

export const clearWelcomeBonusClaim = () => {
  claimedInMemory = false
  try {
    window.sessionStorage.removeItem(CLAIM_KEY)
  } catch {
    // The in-memory claim has already been cleared.
  }
}

export const hasWelcomeBonusClaim = () => {
  try {
    return claimedInMemory || window.sessionStorage.getItem(CLAIM_KEY) === "true"
  } catch {
    return claimedInMemory
  }
}

export const getRegistrationAgent = (agentCode) => {
  if (hasWelcomeBonusClaim()) return ARTICLES_AGENT_CODE
  return agentCode && agentCode !== ARTICLES_AGENT_CODE ? agentCode : "ANOBA"
}
